// export const  uri = "https://dev.backend.algovicrm.com/api";
// export const  cdn = "https://dev.backend.algovicrm.com/";

import { apiUrl } from "services/config/secrets";

export const  uri = apiUrl + "/api";
export const  cdn = apiUrl+"/";
export const  USA = 'United States of America';

// export const  uri = `${apiUrl}/api`;
// export const  cdn = apiUrl + "/";